import React from 'react';
import ServicePage from '../components/ServicePage';
import img from '../assets/service5_1.jpeg';

const overview = [
  'Dedicated Onsite IT Resources providing end-to-end IT infrastructure support and management.',
  'End-User & Infrastructure Support including troubleshooting for end computing, printing, networking, security, servers, and storage systems.',
  'Vendor & OEM Coordination for warranty management, service requests, and issue resolution.',
  'Data Backup & SLA-Based Support Services including helpdesk ticketing, reporting, and escalation management.',
  'Patch Management & Performance Reporting with regular updates and monthly/quarterly reports.',
  'Proactive IT Monitoring & Health Checks with asset tracking and periodic system assessments.'
];

const features = [
  { title: 'IT Audit & Recommendations', text: "Suggestion of Industry best practices & State of the art technologies that can provide edge to the customer's business." },
  { title: 'System Management',          text: 'Complete management of servers, Storage, networks & end point devices' },
  { title: 'Security Management',        text: 'Continuous security monitoring and threat prevention and hence a protected eco system' },
  { title: 'Technical Support',          text: 'Expert support team available when you need them. Multiple choices of SLA based support' }
];

function ManagedITService() {
  return (
    <ServicePage
      title="Managed IT Support Services"
      subtitle="Proactive IT management and support"
      img={img}
      imgAlt="Managed IT Support Services"
      overview={overview}
      features={features}
      backAnchor="managed-it"
    />
  );
}

export default ManagedITService;
